import React from 'react';

const TYPE_CONFIG = {
  pdf:  { bg: 'bg-red-100',    text: 'text-red-600',    label: 'PDF'  },
  doc:  { bg: 'bg-blue-100',   text: 'text-blue-600',   label: 'DOC'  },
  docx: { bg: 'bg-blue-100',   text: 'text-blue-600',   label: 'DOCX' },
  xlsx: { bg: 'bg-green-100',  text: 'text-green-600',  label: 'XLSX' },
  xls:  { bg: 'bg-green-100',  text: 'text-green-600',  label: 'XLS'  },
  jpg:  { bg: 'bg-purple-100', text: 'text-purple-600', label: 'JPG'  },
  jpeg: { bg: 'bg-purple-100', text: 'text-purple-600', label: 'JPG'  },
  png:  { bg: 'bg-purple-100', text: 'text-purple-600', label: 'PNG'  },
  gif:  { bg: 'bg-purple-100', text: 'text-purple-600', label: 'GIF'  },
  webp: { bg: 'bg-purple-100', text: 'text-purple-600', label: 'WEBP' },
  txt:  { bg: 'bg-gray-100',   text: 'text-gray-500',   label: 'TXT'  },
  csv:  { bg: 'bg-green-100',  text: 'text-green-600',  label: 'CSV'  },
};

const DEFAULT_CONFIG = { bg: 'bg-gray-100', text: 'text-gray-500', label: 'FILE' };

export default function FileIcon({ ext, size = 'md' }) {
  const cfg = TYPE_CONFIG[(ext || '').toLowerCase()] || DEFAULT_CONFIG;
  const label = cfg.label.length > 4 ? cfg.label.slice(0, 4) : cfg.label;
  const sizeClass = size === 'sm' ? 'w-8 h-8 text-[9px]' : 'w-9 h-9 text-[10px]';
  return (
    <div className={`${sizeClass} ${cfg.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
      <span className={`font-bold ${cfg.text} tracking-tight`}>{label}</span>
    </div>
  );
}
